import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

const SavitaTestimonial = () => {
  return (
    <section className="section-padding bg-[#f8f9fc]">
      <div className="container-custom">
        <div className="bg-gradient-to-br from-purple-50 to-white rounded-2xl shadow-lg p-8 md:p-12">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16">
            {/* Left side - Image */}
            <div className="w-full md:w-1/3">
              <div className="relative">
                <div className="absolute top-0 left-0 w-20 h-20 md:w-32 md:h-32 bg-cs-accent-yellow/30 rounded-full -z-10 transform -translate-x-1/4 -translate-y-1/4"></div>
                <Avatar className="w-40 h-40 md:w-56 md:h-56 border-4 border-white shadow-md mx-auto">
                  <AvatarImage src="/lovable-uploads/f43f2ea3-47bc-46f6-a49c-b3daf8830a55.png" alt="Savita Hortikar" className="object-cover" />
                  <AvatarFallback className="bg-cs-primary/10">SH</AvatarFallback>
                </Avatar>
              </div>
            </div>
            
            {/* Right side - Testimonial content */}
            <div className="w-full md:w-2/3">
              <div className="space-y-6">
                <blockquote>
                  <p className="text-lg md:text-xl font-medium text-cs-dark-grey leading-relaxed mb-4 relative italic">
                    <span className="absolute -left-2 -top-2 text-4xl text-cs-primary opacity-20">"</span>
                    To staff for a critical client project at Fractal, we chose Cutshort over conventional vendors for their data and quality advantage. We not only hired 15+ AI & ML engineers but are also super impressed with the quality of the recruitment funnel. We saw <span className="font-bold text-cs-primary">2x more offer rate</span> and <span className="font-bold text-cs-primary">50% higher joining rates</span>.
                  </p>
                </blockquote>
                
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="text-lg font-semibold text-cs-dark-grey">Savita Hortikar</h4>
                    <p className="text-cs-medium-grey">Head of Talent Acquisition, Fractal Analytics</p>
                  </div>
                  <img src="/lovable-uploads/Fractal.png" alt="Fractal Analytics" className="h-8 md:h-10" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SavitaTestimonial;
